<template>
  <a
    class="product-card"
    :class="{
      [$class('loading')]: !product,
      'show-secondary-image': showSecondaryImage,
    }"
    :href="product.url"
    @focus="loadSecondaryImage = true"
    @mouseenter="loadSecondaryImage = true"
  >
    <div class="product-card__image-container">
      <responsive-image
        class="product-card__primary-image"
        :image="product.featuredImage"
        min-max="200-500"
        ratio="1:1"
        sizes="(min-width: 1024px) 25vw, 50vw"
      />

      <responsive-image
        v-if="loadSecondaryImage && product.secondaryImage"
        class="product-card__secondary-image"
        :image="product.secondaryImage"
        min-max="200-500"
        :padding="false"
        ratio="1:1"
        sizes="(min-width: 1024px) 25vw, 50vw"
        @image-loaded="showSecondaryImage = true"
      />
    </div>

    <div class="product-card__footer">
      <p
        class="
          product-card__vendor
          text-other-label-s
          text-other-label-l-desktop
        "
        v-text="product.vendor"
      />

      <p
        class="
        product-card__title
        text-heading-s
        text-heading-m-desktop
      "
        v-text="product.title"
      />

      <product-prices
        class="product-card__prices"
        :available="product?.available"
        :compare-at-price="product?.compareAtPrice?.amount"
        :price="product?.price?.amount"
        :varies="product?.price?.varies"
      />
    </div>
  </a>
</template>

<script>

/**
 * Vue: Product card (product-card)
 * -----------------------------------------------------------------------------
 * Product card used throughout the site.
 *
 * @param {Boolean|Object} product - Product object, false shows loading state.
 *
 */
import ProductPrices from '~global/product-prices/product-prices'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'ProductCard',

  components: {
    ProductPrices,
    ResponsiveImage,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },

  data() {
    return {
      loadSecondaryImage: false,
      showSecondaryImage: false,
    }
  },
}
</script>

<style lang="scss">
@import './product-card';
</style>
